export const healthCheckUrlRoute = "/healthz";
